import { IApplicationState, IGetState, TCardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { getCard } from '../../../../../../../../../store/model/selectors/getCard';
import { cardRestGetSections } from '../../../../../../../../../rest/effects/card/card/api/helper/cardRestGetSections';
import { IRestPinnedSections } from '../../../../../../../../../types/rest/IRestCardMeta';
import {
    getCardChecklists
} from '../../../../../../../../../store/model/checklists/checklists/selectors/getCardChecklists';
import { getCardSubcardsCount } from '../../../../../../../../../store/model/selectors/getCardSubcardsCount';
import { getCardSubcardsSorted } from '../../../../../../../../../store/model/selectors/getCardSubcards';
import {
    getDriveDocsByCardId,
    getDriveDocsByCardIdCreateSelector
} from '../../../../../../../../../store/model/driveDocs/selectors/getDriveDocsByCardId';
import { ERestDriveDocType } from '../../../../../../../../../types/rest/IRestDriveDoc';

export const onLoadData = (
    cardId: TCardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const sections: Array<keyof IRestPinnedSections> = [];
        const state = getState();
        if (getNeedToLoadChecklists(state, cardId)) {
            sections.push('checklists');
        }
        if (getNeedToLoadComments(state, cardId)) {
            sections.push('comments');
            sections.push('attachments'); // могут быть комментарии с атачментами
        }
        if (!sections.includes('attachments') && getNeedToLoadAttachments(state, cardId)) {
            sections.push('attachments');
        }
        if (!sections.length) return Promise.resolve();
        return dispatch(cardRestGetSections([{
            cardId,
            sections,
        }]));
    };
    return action;
};

const getNeedToLoadChecklists = (
    state: IApplicationState,
    cardId: TCardId,
): boolean => {
    const { checklistStats } = getCard(state, cardId);
    const { totalCount = 0, checkedCount = 0 } = checklistStats || {};
    const _totalCount = Object.values(getCardChecklists(state, cardId)).reduce((totalCount, checklist) => {
        if (checklist && checklist.checkItems) {
            totalCount += Object.values(checklist.checkItems).length;
        }
        return totalCount;
    }, 0);
    return totalCount > _totalCount;
}

const getNeedToLoadAttachments = (
    state: IApplicationState,
    cardId: TCardId,
): boolean => {
    let driveDocCount = getCard(state, cardId).driveDocCount || 0;
    return getDriveDocsByCardId(state, cardId, ERestDriveDocType.CARD, undefined, false).length !==
        driveDocCount;
}

const getNeedToLoadComments = (
    state: IApplicationState,
    cardId: TCardId,
): boolean => {
    const { commentCount = 0, comments = [] } = getCard(state, cardId);
    return commentCount !== comments.length;
}
